export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const PROJECT_SELECTION = 'PROJECT_SELECTION'
export const COURSE_SELECTION = 'COURSE_SELECTION'
export const ASSESSMENT_SELECTION = 'ASSESSMENT_SELECTION'
export const RECEIVE_RESULTS = 'RECEIVE_RESULTS'
export const ASSESSMENT_RESULT = 'ASSESSMENT_RESULT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js